import { ref } from 'vue'

// Tracks one fetch for a list: { loading, failed, run }.
// run(fn) calls fn(); a thrown error or a null/undefined result counts as a
// failure (api-service helpers return null on error). Returns the result, or
// null on failure. Overlapping runs: only the latest one updates the state.
export function useLoadState() {
  const loading = ref(false)
  const failed = ref(false)
  let seq = 0
  async function run(fn) {
    const mine = ++seq
    loading.value = true
    failed.value = false
    let result = null
    try {
      result = await fn()
    } catch (e) {
      console.error('Load failed:', e)
      result = null
    }
    if (mine === seq) {
      failed.value = result == null
      loading.value = false
    }
    return result
  }
  return { loading, failed, run }
}
